<div class="pl-2">
  <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
</div>
@if (!isOffline) {
  <div class="card-body">
    <form ngNoForm #KortextForm target="_target"  action="{{formActionUrl}}" method="POST">
      <input name="lis_person_contact_email_primary" type="hidden" [value]="email">
      <input name="lis_person_name_full" type="hidden" [value]="fullName">
      @if (hasCustomId()) {
        <input name="custom_id" type="hidden" [value]="customId">
      }
      @if (hasCustomPage()) {
        <input name="custom_page" type="hidden" [value]="customPage">
      }
      <input name="context_label" type="hidden" [value]="contextLabel">
      <input name="context_title" type="hidden" [value]="contextTitle">
      <input name="oauth_consumer_key" type="hidden" [value]="oauthConsumerKey">
      <input name="oauth_timestamp"  type="hidden" [value]="oauthTimestamp">
      <input name="oauth_signature"  type="hidden" [value]="oauthSignature">
      <span class="d-none d-print-block"><i class="fas fa-exclamation-circle fa-fw"></i> Please go to your student portal to interact with your eBook account</span>
      <button type="button" class="btn btn-primary" (click)="completeFormDataWithTimeStampAndSignature()" >{{getButtonText()}}</button>
    </form>
  </div>
}